/* global Highcharts module window:true */
(function (factory) {
    if (typeof module === "object" && module.exports) {
        module.exports = factory;
    } else {
        factory(Highcharts);
    }
}(function (Highcharts) {

    Highcharts.setOptions({
        chart: {
            style: {
                fontFamily: "Roboto, Arial, Helvetica, sans-serif",
                fontSize: "14px"
            }
        },
        title: {
            style: {
                fontSize: "16px"
            }
        }
    });

}));
